<template>
     <div>
        <div class="splide" id="category-slider">
            <div class="splide__track">
                <ul class="splide__list">
                    <li class="splide__slide" v-for="(category, k) in categories" :key="k"
                        @click="clickCategory(category, k)">
                        <div v-if="k == tabActive">
                            <div class="icon">
                                <img class="img_fluid" :src="category.image_url_active" />
                            </div>
                            <div class="text" :class="{'active': k == tabActive}">
                                <div class="text-name">
                                    {{locale === 1054 ? category.name_th : category.name_en}}
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <div class="icon">
                                <img class="img_fluid" :src="category.image_url_inactive" />
                            </div>
                            <div class="text" :class="{'active': k == tabActive}">
                                <div class="text-name">
                                    {{locale === 1054 ? category.name_th : category.name_en}}
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
//base
import Account from "@/helper/AccountHelper.js";
//plugin
// import Carousel from 'vue-owl-carousel';
//service
import BzbsCategory from "@/core/Campaign/service/BzbsCategory.js";
//library
import Splide from '@splidejs/splide'; //https://splidejs.com/
import { Grid } from '@splidejs/splide-extension-grid';
export default {
    name: 'CategorySlider',
    components: {
        // Carousel
    },
    props: {
        locale: Number,
        categoryConfig: Object,
        busEvent: Object,
        tracking: Object
    },
    data: function () {
        return {
            currentTab: '',

            categories: [],
            isHaveCategory: false,
            isLoaded: false,
            tabActive: 0,
            slider: null,
            currentSliderIndex: 0,
        };
    },mounted: function () {
        this.busEvent.$on("switchLang", this.switchLang);
    },
    created: function () {
        this.initialCategory();
       
    },
    methods: {
        clickCategory: function (category, key) {
            this.tabActive = key;
            this.$emit('changeCategory', category);
            let trackCamp = category.id + "|" + category.name;
            this.tracking.event('reward_category', 'click_reward_category', trackCamp);
        },
        initialCategory: function () {
            var categoryParam = this.categoryConfig
                .getParams();
 
            var token = Account.getToken();
            BzbsCategory.apiGetCategory(token, categoryParam).subscribe((categories) => {

                for (var category of categories) {
                    this.categories.push(category);
                }
                this.isLoaded = true;
                this.isHaveCategory = this.categories.length > 0
                    ? true
                    : false;
                this.setSlider();
                if (this.categoryConfig.catId) { 
                    for(let i=0; i < categories.length; i++) {
                        let item = categories[i];
                        if (item.id == this.categoryConfig.catId) {
                            this.tabActive = i;
                            break;
                        }
                    }
                }

                //this.clickCategory(this.categories[0], 0);
            }, (err) => {
                this.isLoaded = true;
                this.isHaveItem = false;
                console.log(err);
            });
        },
        setSlider: function() {
            this.$nextTick(() => {
                this.slider = new Splide('#category-slider', {
                    type: 'slide',
                    arrows: false,
                    grid: {
                        rows: 2,
                        cols: 4,
                        gap : {
                            row: '1rem',
                            col: '12px',
                        },
                    },
                }).mount({ Grid });
                this.slider.on('move', (newIndex) => {
                    this.currentSliderIndex = newIndex;
                });
            });
        },
        getImageCategory: function(category){
            console.log(category);
            
            var isActive = false;
            if(category.id == this.selectedCategory){
                isActive = true;
            }else{
                isActive = false;
            }

            if (category.image_url == undefined)
                return  '/img/icon/icon-all.svg';
            else
                return isActive ? category.image_url_active : category.image_url_inactive;
        },
        switchLang: function() {
            this.categories = [];
            this.initialCategory();
        },
    }
}
</script>
<style lang="scss">
@import "@/style/base/base.scss";
@import "@/style/base/baseDisplay.scss";
@import "@/style/base/baseText.scss";
#category-slider{
    margin: auto;
    padding: 24px 22px 0px;
    width: 100%;
    // .splide__track {
    //     padding-bottom: 16px;
    // }
    .splide__pagination{
        position: relative;
        bottom: 0px;
    }
    .splide__pagination__page{
        height: 6px;
        width: 6px;
        background: $a-gray-e6eaeb;
        opacity: 1;
    }
    .splide__pagination__page.is-active{
        width: 14px;
        background: $yellow;
        border-radius: 4px;
        transform: unset;
    }
    .icon {
        width: 48px;
        height: 48px;
        margin: auto;
        img {
            width: 48px;
            height: 48px;
            border-radius: 50%;
            box-shadow: $box-shadow;
        }
    }
    .text{
        color: $border-gray;
        font-size: 0.875rem;
        margin-top: 6px;
        width: 100%;
        font-family: "Light";

        &.active {
            color:$white;
        }
        .text-name{
            @extend %ellipsis-2;
            text-align: center;
            line-height: 17px;
            word-break: break-word;
        }
    }
}
</style>
